import * as React from "react";
import { useProvider } from "../../Context";

const initialState = {
  token: null,
  user: {},
  features: [],
  contracts: {},
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    case "setTokenResult":
      return { ...state, token: payload };
    case "setUser":
      return { ...state, user: payload };
    case "setFeatures":
      return { ...state, features: payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useAuthReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function () {
  const {
    auth: { state, dispatch },
  } = useProvider();

  function login({ token, user, features }) {
    localStorage.setItem("admintoken", token);
    localStorage.setItem("adminuser", JSON.stringify(user));
    localStorage.setItem("features", features);
    dispatch({ type: "set", payload: { token, user, features } });
  }

  function logout() {
    localStorage.clear();
    dispatch({
      type: "set",
      payload: { 
        token: null,
        user: {},
        features: [],
        contracts: {},
      },
    });
  }

  function setContracts(contracts) {
    dispatch({
      type: "set",
      payload: {
        contracts,
      },
    });
  }

  return {
    state: state,
    dispatch: dispatch,
    login,
    logout,
    setContracts,
  };
}
